if (!customElements.get("product-form")) {
  let frequentlyPurchased = false;

  let cart;

  try {
    cart = new CartItems();
  } catch (e) {}


  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.form.classList.contains("frequently-purchased-form")) {
          frequentlyPurchased = true;
        }

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        if (frequentlyPurchased) {
          config.body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections: cart
              .getSectionsToRender()
              .map((section) => section.section),
            sections_url: window.location.pathname,
          });
        } else {
          config.body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections: this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id),
            sections_url: window.location.pathname,
          });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            if (frequentlyPurchased) {
              submitButton.classList.add("added");
              submitButton.textContent = "";
              setTimeout(() => {
                cart.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document
                      .getElementById(section.id)
                      .querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = cart.getSectionInnerHTML(
                    response.sections[section.section],
                    section.selector
                  );
                });
                recalculateCart();
                window.scrollToCustom(0);
              }, 500);
            } else {
              window.location.href = '/cart/'
              //this.cartNotification.renderContents(response);
            }
          })
          .then((response) => {})
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        setTimeout(() => {
          this.errorMessageWrapper.setAttribute("hidden", "hidden");
        }, 3000);
      }
    }
  );
}
